module.exports = __webpack_public_path__ + "img/a9dx2-gu8od.558943dd.png";